const Close = () => {
  return (
    <svg className="Close" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 17.1 17.1" style={{enableBackground: 'new 0 0 17.1 17.1'}} xmlSpace="preserve">
    <style type="text/css" dangerouslySetInnerHTML={{__html: "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#010101;}\n" }} />
    <g id="XMLID_839_">
      <circle id="XMLID_854_" className="st0" cx="8.5" cy="8.5" r="8.5" />
      <g id="XMLID_856_">
        <path id="XMLID_858_" className="st1" d="M8.5,6.4l3.2-4.5c-1-0.5-2-0.7-3.2-0.7c-1.1,0-2.2,0.3-3.1,0.7L8.5,6.4z" />
        <path id="XMLID_859_" className="st1" d="M13.6,3.2l-3.6,5l3.8,5.5c1.3-1.3,2.1-3.1,2.1-5.1C15.9,6.4,15,4.5,13.6,3.2z" />
        <path id="XMLID_860_" className="st1" d="M8.5,10L5.1,15c1,0.6,2.2,0.9,3.5,0.9c1.2,0,2.4-0.3,3.4-0.8L8.5,10z" />
        <path id="XMLID_861_" className="st1" d="M7,8.2l-3.6-5C2,4.5,1.2,6.4,1.2,8.5c0,2,0.8,3.8,2.1,5.1L7,8.2z" />
      </g>
    </g>
    <style jsx>
    {`
    .Close {
      position:absolute;
      right:0px;
      top:0px;
      transform:translate(-50%, -50%);
      width:2.8125rem;
      height:2.8125rem;
      z-index: 1;
    }
    `}
    </style>
  </svg>
  )
}


export default Close;